import { DiversityIcon } from '@/components/icons/be-guardian/diversity'
import { EditorChoiceIcon } from '@/components/icons/be-guardian/editor-choice'
import { PreservedAreaIcon } from '@/components/icons/be-guardian/preserved-area'
import { Skeleton } from '@/components/skeleton'
import { abbreviateNumber } from '@/helper/abbreviate-number'

import { IndicatorsTooltip } from './indicators-tooltip'

interface IndicatorsCardProps {
  title: string
  urlImage: string
  quantityOfProjects: string
  quantityOfConservatives: string
  quantityOfPreservedArea: string
}

export function IndicatorsCard(props: IndicatorsCardProps) {
  const {
    quantityOfConservatives,
    quantityOfPreservedArea,
    quantityOfProjects,
    title,
    urlImage,
  } = props

  const totalAreaPreserved = Number(quantityOfPreservedArea)

  return (
    <div className="relative h-72 w-full max-w-124">
      <div className="relative h-full w-3/4 overflow-hidden rounded-2xl transition-transform duration-300 ease-in-out hover:scale-95">
        {urlImage ? (
          <img
            title={title}
            className="size-full object-cover"
            src={urlImage}
            alt={`image from ${title}`}
          />
        ) : (
          <Skeleton className="size-full" />
        )}

        <h3
          title={title}
          className="absolute bottom-0 w-full bg-linear-to-t from-bios-primary to-bios-title px-4 py-2 text-center text-xl uppercase tracking-wide text-white opacity-90 md:text-2xl lg:text-start"
        >
          {title}
        </h3>
      </div>

      {/* Card */}
      <div className="absolute right-0 top-4 z-20 w-full max-w-60 rounded-2xl bg-white px-4 py-3 shadow-sm lg:top-1/2 lg:h-full lg:max-h-60 lg:-translate-y-1/2">
        <div className="flex h-full flex-col gap-4">
          <div className="flex items-center gap-2">
            <EditorChoiceIcon className="size-7 text-bios-secondary" />

            <div className="flex flex-col gap-px">
              <span
                className="text-lg font-bold text-bios-primary sm:text-xl"
                data-wg-notranslate
              >
                {quantityOfProjects}
              </span>

              <span className="text-monochromatic-500">
                {Number(quantityOfProjects) <= 1 ? 'projeto' : 'projetos'}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <DiversityIcon className="size-7 text-bios-secondary" />

            <div className="flex flex-col gap-px">
              <span
                className="text-lg font-bold text-bios-primary sm:text-xl"
                data-wg-notranslate
              >
                {quantityOfConservatives}
              </span>

              <span className="text-monochromatic-500">
                {Number(quantityOfConservatives) <= 1
                  ? 'conservador'
                  : 'conservadores'}
              </span>
            </div>
          </div>

          <IndicatorsTooltip totalAreaPreserved={totalAreaPreserved}>
            <div className="flex items-center gap-2">
              <PreservedAreaIcon className="size-7 text-bios-secondary" />

              <div className="flex flex-col gap-px">
                <span
                  className="text-start text-lg font-bold text-bios-primary sm:text-xl"
                  data-wg-notranslate
                >
                  {abbreviateNumber(totalAreaPreserved, false)}
                </span>

                <span className="text-monochromatic-500">
                  {totalAreaPreserved <= 1 ? 'área' : 'áreas'} preservada (ha)
                </span>
              </div>
            </div>
          </IndicatorsTooltip>
        </div>
      </div>
      {/* Card */}
    </div>
  )
}
